// src/app/guard/PermissionGuard.tsx
import { Navigate, Outlet } from "react-router-dom";
import { getAuth } from "@/api/client";

export default function PermissionGuard({ module }: { module: string }) {
  const auth = getAuth();
  const modules: string[] = auth?.user?.modules ?? [];

  if (!modules.map(m => m.toLowerCase()).includes(module.toLowerCase())) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
